import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from 'utils/utils';

let env = process.env.REACT_APP_B2B_API_BASE_URL

export const driverApi = async (vendor) => {
  let url = ""
  const page = vendor?.page === 0 || vendor?.page ? vendor?.page+1 : 1
  if(vendor?.driverId){
    url = `${env}${API_ENDPOINT.Driver.api+"/"+vendor.driverId+'?isB2B=true'}`
  }else if(vendor?.id){
    url = `${env}${API_ENDPOINT.Driver.api+"?parentId="+vendor?.id+'&isB2B=true'+"&status="+(vendor?.status?vendor?.status:'')+"&location="+(vendor?.location?vendor?.location:'')+"&dateFrom="+(vendor?.dateFrom?vendor?.dateFrom:'')+"&dateTo="+(vendor?.dateTo?vendor?.dateTo:'')+"&page="+page+"&pageSize="+(vendor?.pageSize?vendor?.pageSize:'')+"&search="+(vendor?.search?vendor?.search:'')}`
  }else if(vendor?.subVendorId){
    url = `${env}${API_ENDPOINT.Driver.api+"?parentId="+vendor?.subVendorId+'&isB2B=true'+"&status="+(vendor?.status?vendor?.status:'')+"&location="+(vendor?.location?vendor?.location:'')+"&dateFrom="+(vendor?.dateFrom?vendor?.dateFrom:'')+"&dateTo="+(vendor?.dateTo?vendor?.dateTo:'')+"&page="+page+"&pageSize="+(vendor?.pageSize?vendor?.pageSize:'')}`
  }else if(vendor?.assignId && !vendor?.allot){
    url = `${env}${API_ENDPOINT.Driver.api+"?parentId="+vendor?.assignId+'&isB2B=true'+"&type="+vendor?.type}`
  }else if(vendor?.allot){
    url = `${env}${API_ENDPOINT.Driver.api+"?parentId="+vendor?.assignId+'&isB2B=true'+"&allot="+vendor?.allot+"&page="+page+"&pageSize="+(vendor?.pageSize?vendor?.pageSize:'')}`
  }else if(vendor?.status || vendor?.search || vendor?.pageSize || page){
    url = `${env}${API_ENDPOINT.Driver.api+"?&status="+(vendor?.status?vendor?.status:'')+'&isB2B=true'+"&location="+(vendor?.location?vendor?.location:'')+"&dateFrom="+(vendor?.dateFrom?vendor?.dateFrom:'')+"&dateTo="+(vendor?.dateTo?vendor?.dateTo:'')+"&page="+page+"&pageSize="+(vendor?.pageSize?vendor?.pageSize:'')+"&search="+(vendor?.search?vendor?.search:'')}`
  }else{
    url = `${env}${API_ENDPOINT.Driver.api}`
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const addDriverApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.Driver.api}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateDriverApi = async (data) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Driver.api+'/' + data.driverId}`, data.data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const matrixDriverApi = async (data) => {
  let url = ""
  if(data?.driverId){
    url = `${env}${API_ENDPOINT.Driver.matrixApi+"/"+data.driverId+'?duration='+data?.duration}`
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const ticketDriverApi = async (data) => {
  let url = ""
  if(data?.driverId){
    url = `${env}${API_ENDPOINT.Driver.ticketApi+"/"+data.driverId}`
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const moreDriverApi = async (data) => {
  let url = ""
  if(data?.driverId){
    url = `${env}${API_ENDPOINT.Driver.moreApi+"/"+data.driverId}`
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};